export {};

export function statusStyleApplication(status: string) {
    switch (status) {
        case "Geweigerd":
            return "#da1e28";
        case "Gunstig":
        case "Positief":
            return "#24A148";
        case "PositiefWaarschuwing":
            return "#f99500";
        case "In behandeling":
            return "#f1c21b";
        case "Onvolledig":
            return "#ff832b";
        case "Ingediend":
            return "#0043ce";
        case "Goed te keuren":
            return "#0043ce";
        case "Uit dienst":
            return "#ff832b";
        default:
            return "#6f6f6f";
    }
}

export function statusStyleCertificate(status: string) {
    switch (status) {
        case "Ingetrokken":
            return "#da1e28";
        case "Geldig":
            return "#24A148";
        case "Toekomstig geldig":
            return "#f1c21b";
        case "Verlopen":
        case "Uit dienst":
            return "#ff832b";
        case "Goed te keuren":
            return "#0043ce";
        default:
            return "#6f6f6f";
    }
}

export function fileTypeStyle(fileType: string) {
    switch (fileType.toLowerCase()) {
        case "attest":
        case "aanvraagformulier":
            return "#24a148";
        case "uittreksel strafregister":
            return "#da1e28";
        case "vertrouwelijkheidsovereenkomst":
            return "#ff832b";
        case "databank bevraging":
            return "#f1c21b";
        case "correspondentie":
            return "#0043ce";
        default:
            return "#6f6f6f";
    }
}
